import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'status',
    state: {
        activeProject: [],
        activeProjectkk: []
    },
    getters: {
        getActiveProject: state => {
            return state.activeProject
        },
        getActiveProjectkk: state => {
            return state.activeProjectkk
        },
    },
    mutations: {
        SET_ACTIVE_PROJECT: (state, payload) => {
            state.activeProject = payload
        },
        SET_ACTIVE_PROJECTKK: (state, payload) => {
            state.activeProjectkk = payload
        },
    },
    actions: {
        async FETCH_ACTIVE_PROJECT(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "project/activeproject",
                params: {
                    tlc: store.rootState.user.auth.username
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_ACTIVE_PROJECT', response.data.data)
            })
                .catch(err => {
                    return err
                });
        },
        async FETCH_ACTIVE_PROJECTKK(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "project/activeprojectkk",
                params: {
                    tlc: store.rootState.user.auth.username
                },
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('SET_ACTIVE_PROJECTKK', response.data.data)
            })
                .catch(err => {
                    return err
                });
        },
    }
}